import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "../../styleSheet/main/components/TODO/createMyTODO/createMyTODO.css";
import deleteButtonIcon from "./../../media/delete-button.svg"; // Import ikony
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { pl } from "date-fns/locale";
import httpClient from "../../services/httpClient.js";
import { useNotification } from "../NotificationContext";
import { useAuth } from "../../AuthContext";

const CreateMyTODO = ({ onClose, onCreate }) => {
  const { t } = useTranslation();
  const { userData } = useAuth();
  const [newTaskText, setNewTaskText] = useState("");
  const [newTaskDate, setNewTaskDate] = useState(null); // Przechowywanie daty w newTaskDate
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  // const { showNotification } = useNotification();

  // Zmieniona funkcja ustawiająca datę
  const handleDepartureDateChange = (date) => {
    setNewTaskDate(date); // Aktualizacja stanu daty
  };

  const handleCreateTask = async () => {
    if (newTaskText && newTaskDate) {
      setIsLoading(true);

      try {
        // Formatuj datę do formatu YYYY-MM-DD
        const formattedDate = newTaskDate.toISOString().split("T")[0];

        // Przygotuj dane do wysłania
        const taskData = {
          title: newTaskText,
          dueDate: formattedDate,
          assigneeId: userData.userId,
        };

        // Wyślij zadanie na backend
        const response = await httpClient.post("/ToDoTasks/assign", taskData, {
          withAuth: true,
        });

        // Powiadom o sukcesie
        // showNotification("Zadanie zostało utworzone pomyślnie!", "success");

        // Wywołaj callback do rodzica (dla kompatybilności z istniejącym kodem)
        if (onCreate) {
          onCreate({ text: newTaskText, date: newTaskDate });
        }

        // Zamknij modal
        onClose();
      } catch (error) {
        // showNotification(
        //   `Błąd podczas tworzenia zadania: ${error.message}`,
        //   "error"
        // );
      } finally {
        setIsLoading(false);
      }
    }
  };

  // Walidacja formularza - obydwa pola muszą być wypełnione
  const isFormValid = newTaskText !== "" && newTaskDate !== null;

  return (
    <div className="create-task-overlay">
      <div className="create-task-content">
        <img
          src={deleteButtonIcon}
          alt="Zamknij"
          className="close-button"
          onClick={onClose}
        />
        <p>{t("todo.createNewTitle")}</p>
        <div className="form-group">
          <label htmlFor="newTaskText">{t("todo.label.content")}</label>
          <input
            type="text"
            id="newTaskText"
            value={newTaskText}
            onChange={(e) => setNewTaskText(e.target.value)}
          />
        </div>
        <div className="form-group">
          <label htmlFor="newTaskDate">{t("todo.label.date")}</label>
          <DatePicker
            selected={newTaskDate} // Używamy newTaskDate jako stanu
            onChange={handleDepartureDateChange}
            dateFormat="dd-MM-yyyy"
            locale={pl}
            minDate={new Date()}
          />
          {errors.newTaskDate && (
            <span className="error-message">{errors.newTaskDate}</span>
          )}
        </div>
        <button
          onClick={handleCreateTask}
          disabled={!isFormValid || isLoading}
          className={isLoading ? "loading" : ""}
        >
          {isLoading ? t("todo.saving") : t("todo.saveNewTaskSelf")}
        </button>
      </div>
    </div>
  );
};

export default CreateMyTODO;
